import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { DateTime } from 'luxon'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import { ReportFormType } from '../../../../pages/Finance/Reports'
import FormikField from '../../../Formik/FormikField'
import LocalDatePicker, { LocalDatePickerProps } from '../../../DatePicker/LocalDatePicker'
import FormikComboboxField from '../../../Formik/FormikComboboxField'
import UserPicker, { UserPickerProps } from '../../../TagPicker/UserPicker'

export type OngoingFilesReportDto = {
    to: string
    ownerUsers: string[]
    executiveUsers: string[]
    statuses: string[]
}

function ReportBody(props: ReportFormType): ReactElement {
    const { values, setFieldValue } = useFormikContext<OngoingFilesReportDto>()

    return (
        <>
            <FormikField<LocalDatePickerProps, OngoingFilesReportDto>
                required
                orientation={props.orientation}
                labelKey="base.to"
                fieldName={'to'}
                component={LocalDatePicker}
                componentProps={{
                    isoValue: values.to,
                    onSelectDate: date => setFieldValue('to', date),
                    maxDate: new Date(),
                }}
            />
            <FormikComboboxField<OngoingFilesReportDto, UserPickerProps>
                orientation={props.orientation}
                labelKey="file.filter.owner"
                fieldName={'ownerUsers'}
                component={UserPicker}
            />
            <FormikComboboxField<OngoingFilesReportDto, UserPickerProps>
                orientation={props.orientation}
                labelKey="file.filter.executive"
                fieldName={'executiveUsers'}
                component={UserPicker}
            />
        </>
    )
}

export default function OngoingFilesReportForm(props: ReportFormType): ReactElement {
    return (
        <ReportForm<OngoingFilesReportDto>
            title="Lopende dossiers"
            generationType={DocumentGenerationType.OngoingFiles}
            initialValues={{
                to: DateTime.local().toISODate(),
                ownerUsers: [],
                executiveUsers: [],
                statuses: [],
            }}
            {...props}
        >
            <ReportBody {...props} />
        </ReportForm>
    )
}
